import { LOAD_COMPANY_CHALLENGES_SUCCESS } from "../actions/challenges";


const initialState = {
  companyChallenges: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_COMPANY_CHALLENGES_SUCCESS:
      return { ...state, companyChallenges: action.payload };
    default:
      return state;
  }
}